module.exports = __webpack_public_path__ + "static/media/logo_vertical.dcc04f5d.png";